import { datadogRum } from "@datadog/browser-rum";
import React from "react";
import GenericErrorPage from "src/layout/ErrorPages/GenericErrorPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    datadogRum.addError(error, { componentStack: errorInfo?.componentStack });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <GenericErrorPage />;
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
